// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as UserRoleRepo from "./user-role/repo/UserRoleRepo.bs.js";
import * as CorePricingRepo from "./core-pricing/repo/CorePricingRepo.bs.js";
import * as ModificationRepo from "./pricing-modifications/repo/ModificationRepo.bs.js";
import * as DummyUserRoleRepo from "./user-role/repo/DummyUserRoleRepo.bs.js";
import * as DummyCorePricingRepo from "./core-pricing/repo/DummyCorePricingRepo.bs.js";
import * as ZonesAndClustersRepo from "./zones-and-clusters/repo/ZonesAndClustersRepo.bs.js";
import * as DummyModificationRepo from "./pricing-modifications/repo/DummyModificationRepo.bs.js";
import * as DummyZonesAndClustersRepo from "./zones-and-clusters/repo/DummyZonesAndClustersRepo.bs.js";

function getPricingRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyCorePricingRepo.CorePricingRepo;
  } else {
    return CorePricingRepo.CorePricingRepo;
  }
}

function getUserRoleRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyUserRoleRepo.UserRoleRepo;
  } else {
    return UserRoleRepo.UserRoleRepo;
  }
}

function getModificationRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyModificationRepo.T;
  } else {
    return ModificationRepo.T;
  }
}

function getZonesAndClustersRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyZonesAndClustersRepo.T;
  } else {
    return ZonesAndClustersRepo.T;
  }
}

export {
  getPricingRepo ,
  getUserRoleRepo ,
  getModificationRepo ,
  getZonesAndClustersRepo ,
  
}
/* Config Not a pure module */
